import React from 'react';

import CharityEventDescription from './components/CharityEventDescription';
import CharityEventRules from './components/CharityEventRules';
import ChildrenTitle from 'components/ChildrenTitle';

const CharityEventInfo: React.FC = () => {
    return (
        <>
            <CharityEventDescription />
            <CharityEventRules />
            <ChildrenTitle />
        </>
    );
};

export default CharityEventInfo;
